import dicomParser from 'dicom-parser';

export function parseDicomdir(file) {
  return new Promise((resolve, reject) => {
    console.log('Parsing DICOMDIR file:', file.name);
    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        const arrayBuffer = event.target.result;
        const dataSet = dicomParser.parseDicom(new Uint8Array(arrayBuffer));
        const directoryRecords = dataSet.elements.x00041220;

        if (!directoryRecords || !directoryRecords.items) {
          reject(
            new Error(
              'Nenhum registro encontrado em x00041220. Verifique se o arquivo DICOMDIR está correto.'
            )
          );
          return;
        }

        const records = [];
        let currentStudy = null;
        let currentSeries = null;

        for (const item of directoryRecords.items) {
          const record = item.dataSet;
          const recordType = record.string('x00041430'); // Directory Record Type

          switch (recordType?.trim().toUpperCase()) {
            case 'STUDY':
              currentStudy = {
                studyInstanceUID: record.string('x0020000d') || 'unknown',
                studyID: record.string('x00200010') || 'N/A',
                studyDate: record.string('x00080020') || 'N/A',
                studyDescription: record.string('x00081030') || 'N/A',
                patientName: record.string('x00100010') || 'N/A',
                patientID: record.string('x00100020') || 'N/A',
              };
              break;

            case 'SERIES':
              if (currentStudy) {
                currentSeries = {
                  seriesInstanceUID: record.string('x0020000e') || 'unknown',
                  seriesNumber: record.string('x00200011') || 'N/A',
                  modality: record.string('x00080060') || 'N/A',
                  seriesDescription: record.string('x0008103e') || 'N/A',
                };
              }
              break;

            case 'IMAGE':
              if (currentStudy && currentSeries) {
                records.push({
                  id: records.length + 1,
                  // Study info
                  studyInstanceUID: currentStudy.studyInstanceUID,
                  studyID: currentStudy.studyID,
                  studyDate: currentStudy.studyDate,
                  studyDescription: currentStudy.studyDescription,
                  patientName: currentStudy.patientName,
                  patientID: currentStudy.patientID,
                  // Series info
                  seriesInstanceUID: currentSeries.seriesInstanceUID,
                  seriesNumber: currentSeries.seriesNumber,
                  modality: currentSeries.modality,
                  seriesDescription: currentSeries.seriesDescription,
                  // Image info
                  instanceNumber: record.string('x00200013') || 'N/A',
                  referencedFile: record.string('x00041500') || 'N/A',
                });
              }
              break;

            // Optionally handle other record types or a default case
            default:
              // Handle unknown record types if necessary
              break;
          }
        }

        resolve(records);
      } catch (error) {
        reject(
          new Error(`Erro ao parsear o DICOMDIR: ${error.message}. Verifique o formato do arquivo.`)
        );
      }
    };

    reader.onerror = (error) => {
      reject(new Error('Erro ao ler o arquivo. Verifique se o arquivo está corrompido.'));
    };

    reader.readAsArrayBuffer(file);
  });
}
